import Vue from 'vue';

Vue.filter('formatPeriodName', function (value, short = true) {
  const year = value.substring(0, 4);
  const period = parseInt(value.substring(5, 6));
  if (short) {
    return year + ' / ' + period;
  }
  return '';
});

Vue.filter('getContractIcon', function (id, config) {
  if (config && config.material_groups && config.material_groups[id]) {
    return '/img/materialgroups/' + config.material_groups[id].code + '.jpg';
  }
  return '';
});
